import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { DataContext } from "../Context/Context";
import { useHistory } from "react-router-dom";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import { IconPickerItem } from "react-fa-icon-picker";

const useStyles = makeStyles((theme) => ({
  stepTwo: {
    ["@media (min-width:1024px)"]: {
      backgroundColor: "rgb(252, 255, 255)",
      border: "1px solid #00cccc",
      borderRadius: 4,
      padding: 20,
      marginTop: 10,
    },
  },
  logo: {
    width: "40%",
  },
  title: {
    textTransform: "uppercase",
  },
  doneBtn: {
    color: "white",
    fontWeight: "bold",
    width: "80%",
    margin: "50px auto 0 auto",
    textTransform: "uppercase",
    backgroundColor: "#6200ee",
    "&:hover": {
      backgroundColor: "#6200ee",
    },
  },
  categoriesWrapper: {
    width: "80%",
    margin: "50px auto",
    paddingLeft: 0,
  },
  categories: {
    display: "flex",
    justifyContent: "space-between",
  },
  name: {
    margin: "0 5px",
  },
  nameIconWrapper: {
    display: "flex",
  },
}));

export default function WizardStepTwo() {
  const { wizardCategories, checkedCategory, setCheckedCategory } =
    useContext(DataContext);

  const classes = useStyles();
  const history = useHistory();

  const onDone = () => {
    history.push("/wizardstepthree");
  };

  const handleOnChange = (position) => {
    let updatedCheckedCategory = checkedCategory.map((item, index) =>
      index === position ? !item : item
    );
    setCheckedCategory(updatedCheckedCategory);

    wizardCategories[position].isEnabled = true;
  };

  return (
    <div className={classes.stepTwo}>
      <img
        className={classes.logo}
        src={require("../images/logo-text.png").default}
        alt="logo"
      />
      <h1 className={classes.title}>Welcome</h1>
      <p>Choose what you spend money on</p>
      <ul className={classes.categoriesWrapper}>
        {wizardCategories.map((category, index) => {
          return (
            <li key={category.id} className={classes.categories}>
              <div
                htmlFor={`custom-checkbox-${index}`}
                className={classes.nameIconWrapper}
              >
                <IconPickerItem icon={category.icon}>
                  {category.icon}
                </IconPickerItem>
                <p className={classes.name}>{category.name}</p>
              </div>
              <Checkbox
                id={`custom-checkbox-${index}`}
                value={checkedCategory}
                onChange={() => handleOnChange(index)}
              />
            </li>
          );
        })}
      </ul>
      <Button
        type="submit"
        className={classes.doneBtn}
        variant="contained"
        onClick={onDone}
        disabled={
          !wizardCategories.find((category) => category.isEnabled === true)
        }
      >
        Done
      </Button>
    </div>
  );
}
